export enum EmployeeModalTypes {
  AssignDevice,
  EditEmployee,
  EmployeeLeavesFirm,
  NewPhonePlan,
}
